<script>
import {getClientViaShipmentOrders, publishTask} from "@/api/system/customer";
import Fields from "@/view/endTripManage/clearanceQuotationRule/fields.vue";
import {Spin} from "view-design";

export default {
  name: "index",
  components: {Fields},
  inject: ["$page"],
  data() {
    return {
      unpackShipmentNumber: '',
      unpackArray: [],
    }
  },
  methods: {
    checkUniqueShipmentNumber() {
      let temp = this.unpackArray
      temp.push(this.unpackShipmentNumber.toUpperCase())
      this.unpackArray = [...new Set(temp)]
      this.unpackShipmentNumber = ''
    },
    removeItem(item) {
      this.unpackArray = this.unpackArray.filter(v => v !== item)
    },
    publishTask() {
      if (this.unpackArray.length === 0) {
        return this.$Message.error('请录入最少一个CES单号')
      }

      this.$Spin.show()
      // 创建批次信息
      publishTask(this.unpackArray).then(r => {
        this.$Spin.hide()
        if (r.data.status) {
          this.unpackArray = []
          this.unpackShipmentNumber = ''
          this.$Message.success('批次创建成功, 请通知仓库作业')
          setTimeout(() => {
            this.$page.getModal("showUnpack").close()
            this.$page.getList()
          }, 5000)
        } else {
          this.$Message.error(r.data.msg)
        }
      }).catch(e => {
        this.$Message.error(e.message)
      })
    }
  },
}
</script>

<template>
  <div>
    <Form ref="formInline" :label-width="140" @submit.native.prevent>
      <FormItem label="请扫描CES单号">
        <Input
          v-model="unpackShipmentNumber"
          @on-enter="checkUniqueShipmentNumber"
          placeholder="请扫描CES单号"
          style="width:200px"></Input>
      </FormItem>
      <FormItem label="已录入的CES单号">
        <Tag v-for="(item, k) in unpackArray" :key="k" :name="item" size="large" closable @on-close="removeItem(item)">
          {{ item }}</Tag>
      </FormItem>

      <FormItem>
        <Button type="primary" @click="publishTask">创建批次</Button>
      </FormItem>
    </Form>
  </div>

</template>

<style scoped>

</style>
